import React, { useContext, useEffect, useState, useRef } from 'react';
import requests from '../utils/requests.js';
import { PersonContext } from '../providers/Person.jsx';
import Collapsed from './orders/Collapsed.jsx';
import Expanded from './orders/Expanded.jsx';
import { s } from '../Style.jsx';
import Autocomplete from '../common/AutocompleteAddress.jsx';
import AutocompleteAny from '../common/AutocompleteAny.jsx';
import LabeledInput from '../common/LabeledInput.jsx';

const Orders = () => {

    const inputs = useRef([]);
    const focusField = i => {
        if (inputs[i]) {
            inputs[i].focus();
        }
    };

    const { auth, silentNotifications, newNotifications } = useContext(PersonContext);

    const [people, setPeople] = useState([]);
    useEffect(() => { requests.getPeople(auth).then(people => setPeople(people)) }, []);

    const [vendors, setVendors] = useState([]);
    useEffect(() => { requests.getVendors(auth).then(vendors => setVendors(vendors)) }, []);

    const [drivers, setDrivers] = useState([]);
    useEffect(() => { requests.getDrivers(auth).then(drivers => setDrivers(drivers)) }, []);

    const [filters, setFilters] = useState({
        fromDate: new Intl.DateTimeFormat('en-CA', {timeZone: "America/New_York",year: 'numeric',month: '2-digit',day: '2-digit',}).format(new Date()),
        toDate: "",
        complete: false,
    });
    const [orders, setOrders] = useState([]);
    const [gettingOrders, setGettingOrders] = useState(true);
    const [addingOrders, setAddingOrders] = useState(false);
    const [addingToVendor, setAddingToVendor] = useState(false);
    const [addingToDate, setAddingToDate] = useState("");
    useEffect(() => { requests.getDispatchOrders(auth, filters, setGettingOrders).then(orders => setOrders(orders)) }, [newNotifications]);
    useEffect(() => { requests.getDispatchOrders(auth, filters).then(orders => setOrders(orders)) }, [silentNotifications]);

    const [viewingOrder, setViewingOrder] = useState(false);
    useEffect(() => { if (viewingOrder && orders?.length) setViewingOrder(orders.find(o => o.id === viewingOrder.id)); }, [orders]);

    //clear when any variable changes
    const [newOrders, setNewOrders] = useState([""]);
    useEffect(() => {
        setAddingToVendor(false);
        setAddingToDate(false);
        setNewOrders([""]);
    }, [addingOrders]);

    const [reportAll, setReportAll] = useState(false);
    const [reportFrom, setReportFrom] = useState(new Intl.DateTimeFormat('en-CA', {timeZone: "America/New_York",year: 'numeric',month: '2-digit',day: '2-digit',}).format(new Date()));
    const [reportTo, setReportTo] = useState("");
    useEffect(() => {
        if (reportFrom) {
            setFilters({ fromDate: reportFrom, toDate: reportTo, completed: reportAll });
            requests.getDispatchOrders(auth, { fromDate: reportFrom, toDate: reportTo, completed: reportAll }, setGettingOrders).then(orders => setOrders(orders));
        }
    }
        , [reportFrom, reportTo, reportAll]);

    return <>
        <div style={{ ...s.mobileContainer, paddingBottom: 0 }}>

            {!addingOrders && <>

                <div style={s.rowTop}>
                    <button style={s.button} onClick={() => setAddingOrders(true)}>Add Deliveries</button>
                </div>
                <div style={s.row}>
                    <span style={{ flex: 1 }}></span>
                </div>
                <div style={{ ...s.row, marginBottom: 10, alignItems: "center", justifyContent: "flex-end" }}>
                    <div>
                        <LabeledInput boxstyle={{ ...s.row, maxWidth: 300, marginBottom: 4 }} inputstyle={{ minWidth: 160 }} label="From" type="date" value={reportFrom} onChange={setReportFrom} />
                        <LabeledInput boxstyle={{ ...s.row, maxWidth: 300 }} inputstyle={{ minWidth: 160 }} label="To" type="date" value={reportTo} onChange={setReportTo} />
                    </div>
                </div>

                <div style={{ ...s.row, marginBottom: 10 }}>
                    <div>
                        <h3 style={{ marginBottom: 4 }}>New Deliveries</h3>
                        <span style={{ fontSize: 12 }}>from {reportFrom} to {reportTo}</span>
                    </div>
                </div>

            </>}

            {addingOrders && <>

                <h2 style={{ marginBottom: 10 }}><s.BackArrow does={() => setAddingOrders(false)} />New Deliveries</h2>

                <div style={{ ...s.row, marginBottom: 10, alignItems: "center" }}>
                    <label>Vendor</label>
                    <AutocompleteAny options={vendors}
                        additionalOptions={[addingToVendor]}
                        onChangeText={e => {
                            setAddingToVendor({ name: e, id: "" });
                        }}
                        onChange={e => {
                            setAddingToVendor(e);
                        }}
                        type="vendor"
                        selected={addingToVendor.id} />
                </div>

                {addingToVendor.name && <div style={{ ...s.row, marginBottom: 10 }}>
                    <LabeledInput labelstyle={{ width: 100 }} inputstyle={{ width: 160 }} boxstyle={s.row} label="Date" type="date" value={addingToDate || new Date().toLocaleDateString()} onChange={setAddingToDate} />
                </div>}

                {addingToVendor.name && <>
                    <label>Destinations</label>
                    <div style={s.box}>
                        <div style={s.table}>
                            {[...newOrders.filter(e => e), ""].map((order, i) => <div key={i} style={s.cell(0)}>
                                <Autocomplete value={order}
                                    onEnter={(value => {
                                        focusField(i + 1);
                                    })}
                                    onClickPrediction={() => {
                                        focusField(i + 1);
                                    }}
                                    reference={input => inputs[i] = input}
                                    onChange={e => {
                                        let anewOrders = [...newOrders];
                                        anewOrders[i] = e;
                                        setNewOrders(anewOrders);
                                    }} style={{ width: "100%", marginBottom: 0 }} />
                            </div>)}
                        </div>
                    </div>
                    <button style={{ ...s.button, marginRight: 4 }} onClick={() => setAddingOrders(false)}>Cancel</button>
                </>}

                {addingToVendor.name && newOrders.some(e => e) && <>
                    <button style={{ ...s.button }} onClick={() => {
                        setAddingOrders(false);
                        setFilters({});
                        let values;
                        if (addingToVendor.id) {
                            values = { date: addingToDate || new Date().toLocaleDateString(), vendorId: addingToVendor.id, };
                        } else {
                            values = { date: addingToDate || new Date().toLocaleDateString(), pickup: addingToVendor.name, };
                        }
                        requests.createMulti({
                            auth,
                            values,
                            orders: newOrders,
                            setLoading: setGettingOrders,
                            cb: () => requests.getDispatchOrders(auth, { fromDate: reportFrom, toDate: reportTo, completed: reportAll }, setGettingOrders).then(orders => {
                                setOrders(orders);
                            }
                            )
                        });
                    }}>Done</button>
                </>}

            </>}

        </div >
        <div style={{ ...s.desktopScrollContainer }}>
            <div style={s.desktopContainer}>

                {!addingOrders && <>

                    {<div style={{ ...s.box, paddingBottom: 0 }}>
                        <table style={s.table}>
                            <tr style={s.th}>
                                <th style={{ flex: .2 }}></th>
                                <th style={{ ...s.tableCell, flex: .5 }}>Order #</th>
                                <th style={{ ...s.tableCell, flex: 1 }}>Vendor</th>
                                <th style={{ ...s.tableCell, flex: 1 }}>Destination</th>
                                <th style={{ ...s.tableCell, flex: 1 }}>Driver</th>
                                <th style={{ ...s.tableCell, flex: 1 }}>Status</th>
                            </tr>
                            {gettingOrders && <tr style={s.cell(1)}><td><i className="fas fa-spinner fa-spin"></i></td></tr>}

                            {!gettingOrders && orders
                                .filter(o => (!viewingOrder?.id) || (o.id === viewingOrder.id))
                                .map((order, o) => <tr key={o} style={s.cell(o)}>

                                    {<Collapsed
                                        order={order}
                                        setViewingOrder={setViewingOrder}
                                        vendors={vendors}
                                        drivers={drivers}
                                        index={o}
                                    />}

                                </tr>)}
                        </table>
                    </div>}

                </>}

            </div>
        </div>

        <div style={{ ...s.mobileContainer }}>

            {!gettingOrders && !addingOrders && <>

                {viewingOrder?.id && <Expanded
                    resetOrders={() => {
                        requests.getDispatchOrders(auth, { fromDate: reportFrom, toDate: reportTo, completed: reportAll }).then(orders => setOrders(orders));
                    }}
                    deleteOrder={() => requests.deleteOrder(auth, viewingOrder.id, () => requests.getDispatchOrders(auth, { fromDate: reportFrom, toDate: reportTo, completed: reportAll }, setGettingOrders).then(orders => setOrders(orders)))}
                    setOrders={setOrders}
                    setViewingOrder={setViewingOrder}
                    order={viewingOrder}
                    vendors={vendors}
                    drivers={drivers}
                    people={people}
                    orders={orders}
                />}

            </>}

        </div>

    </>;
}

export default Orders;
